import type {NumberInputFieldProps, NumberInputProps} from '@chakra-ui/react';
import {NumberInput, NumberInputField, NumberInputStepper} from '@chakra-ui/react';
import type {FieldPath, FieldValues} from 'react-hook-form';
import {useController} from 'react-hook-form';

import {NumberDecrementStepper, NumberIncrementStepper} from '../../NumberInput';

export type FieldNumberInputProps<TName> = Omit<NumberInputProps, 'name'> & {
  name: TName;
  autoFocus?: boolean;
  inputProps?: NumberInputFieldProps;
};

export const FieldNumberInput = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  autoFocus,
  inputProps,
  ...rest
}: FieldNumberInputProps<TName>) => {
  const {
    field: {ref, ...field},
  } = useController<TFieldValues>({name});

  return (
    <NumberInput
      min={1}
      maxW={60}
      {...field}
      isDisabled={field.disabled}
      onChange={valueAsString => {
        field.onChange({target: {name: field.name, value: valueAsString}});
      }}
      {...rest}
    >
      <NumberInputField ref={ref} autoFocus={autoFocus} {...inputProps} />
      <NumberInputStepper>
        <NumberIncrementStepper />
        <NumberDecrementStepper />
      </NumberInputStepper>
    </NumberInput>
  );
};
